import { NgModule } from '@angular/core'
import { CommonModule, DatePipe } from '@angular/common'
import { SharedModule } from 'app/shared/shared.module'
import { DirectivesModule } from 'app/directives/directive.module'
import { FileUploadComponent } from './file-upload.component'
import { FilePondModule, registerPlugin } from 'ngx-filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginFileEncode from 'filepond-plugin-file-encode'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
import { MatIconModule } from '@angular/material/icon'

registerPlugin(
	FilePondPluginFileValidateType,
	FilePondPluginFileEncode,
	FilePondPluginImageExifOrientation,
	// FilePondPluginImagePreview,
	FilePondPluginFileValidateSize
)

@NgModule({
	declarations: [FileUploadComponent],
	imports: [CommonModule, SharedModule, DirectivesModule, FilePondModule, MatIconModule],
	providers: [],
	exports: [FileUploadComponent]
})
export class FileUploadModule {}
